import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css?external';  // eslint-disable-line

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PhotoIcon from '@material-ui/icons/HowToRegOutlined';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';
import LockIcon from "@material-ui/icons/LockOutlined";
import pdfPreviewImage from "../../assets/img/pdf_preview.jpg";


class ProfileIdProof extends Component {
  state = {
    modalOpen: false,
    imageIndex: null,
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
    });
  }

  previewImage = (index) => {
    this.setState({
      modalOpen: true,
      imageIndex: index,
    });
  }

  render() {
    let idProof = (
      <div align="center" style={{ paddding: '30px' }}>
        <Typography variant="subheading"></Typography>
      </div>
    );

    const photosArr = [];
    if (this.props.profile.idproof.length > 0) {
      if (this.props.profile.idproof[0].file_type === "IMAGE") {
        idProof = this.props.profile.idproof.map((photo, index) => {
          const src = constants.BASE_URL + photo.thumbnail;
          photosArr.push(constants.BASE_URL + photo.preview);
          return (
            <Grid container>
              <Grid item md={3} sm={3} xs={6} key={photo.id} onClick={() => this.previewImage(index)}>
                <img alt={photo.id} src={src} className={classes.profilePhoto} />
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <p className={classes.profileCap}>ID proof No.</p>
                <p className={classes.profileVal}>{this.props.profile.idproof[0].id_proof_no}</p>
                <br />
              </Grid>
            </Grid>
          );
        });
      } else if (this.props.profile.idproof[0].file_type === "PDF") {
        idProof = this.props.profile.idproof.map((item) => {
          const src = constants.BASE_URL + item.file;
          return (
            <Grid container>
              <Grid item md={3} sm={6} xs={12} key={item.id} style={{alignItems:'center'}}>
                <a href={src} target="_blank" rel="noopener noreferrer">
                  <img alt={item.id} src={pdfPreviewImage} className={classes.profilePhoto} />
                </a>
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <p className={classes.profileCap}>ID proof No.</p>
                <p className={classes.profileVal}>{this.props.profile.idproof[0].id_proof_no}</p>
                <br />
              </Grid>
            </Grid>
          );
        });
      }
    }

    let editButton = null;

    if (this.props.profile.is_editable) {
      editButton = (
        <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => this.props.editProfileSection('idproof')}>Edit</Button>
      );
    }

    return (
      <React.Fragment>
        <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
          {editButton}
          <Typography variant="subheading" className={classes.profileSectionTitle}>
            <PhotoIcon className={classes.titleIcon} />
            ID Proof
          </Typography>
          <br />
            {idProof}
        </Paper>
        {this.state.modalOpen && this.props.profile.idproof[0].file_type==="IMAGE" && (
          <Lightbox
            mainSrc={photosArr[this.state.imageIndex]}
            nextSrc={photosArr[(this.state.imageIndex + 1) % photosArr.length]}
            prevSrc={photosArr[(this.state.imageIndex + photosArr.length - 1) % photosArr.length]}
            onCloseRequest={() => this.setState({ modalOpen: false })}
            onMovePrevRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + photosArr.length - 1) % photosArr.length,
            })}
            onMoveNextRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + 1) % photosArr.length,
            })}
          />
        )}
      </React.Fragment>
    );
  }
}


export default ProfileIdProof;



// WEBPACK FOOTER //
// ./src/profile/components/ProfileIdProof.js